import React from 'react';
// import { Link as RouterLink } from 'react-router-dom';
import {Link} from "@material-ui/core";
import Icon from '@material-ui/core/Icon/Icon';
import { menuElementStyles } from '../Styles/MenuElementStyles';

export type GroupElementProps = {
    link: string;
    icon: string;
    text: string;
    newTab?: boolean;
    onClick: () => void
};

const MenuElement = (props: GroupElementProps) => {
    const classes = menuElementStyles();
    const {link, icon, text, newTab, onClick} = props;

    return (
        <div style={{padding: '0 0 !important'}} className={classes.elementWrapper} >
            <div className={classes.element}>
                <Link className={classes.link} 
                    href={link} 
                    target={newTab ? '_blank' : undefined}
                    onClick={onClick}
                > 
                    <div className={classes.elementIcon}>
                        <Icon>
                            {icon.startsWith('i:')
                                ? icon.substr(2)
                                : <img className={classes.icon} src={process.env.PUBLIC_URL + "/" + icon}/>
                            }
                        </Icon>
                    </div>
                    <span className={classes.elementText}>{text}</span>
                </Link>
                
            </div>
        </div>
    );
};

export default MenuElement;
